import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BlobProvider } from '@react-pdf/renderer';
import React from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import ButtonIcon from '../../components/common/ButtonIcon';
import { CREDIT_LINE_ID } from '../../data/constans';
import SolicitudFormato from './formato/SolicitudFormato';
import LibranzaFormato from './libranza/LibranzaFormato';
import { libranzaDesdeFormato } from './libranza/buildLibranzaData';

const Documento = ({ etiqueta, documento, fileName }) => (
    <BlobProvider document={documento}>
        {({ url, loading, error }) => {
            if (loading) {
                return (
                    <span className="fs--1">
                        <Spinner size="sm" color="primary" className="mr-2" />
                        Generando {etiqueta}...
                    </span>
                );
            }
            if (error) {
                return <span className="fs--1 text-danger">No se pudo generar {etiqueta}</span>;
            }
            return (
                <div className="mb-2">
                    <span className="fs--1 mr-2">{etiqueta}</span>
                    {/* Enlace y no window.open: el navegador puede bloquear la
                        ventana emergente sin avisar y el botón queda muerto. */}
                    <ButtonIcon
                        color="falcon-default"
                        size="sm"
                        icon="print"
                        className="mr-2 mb-2 mb-sm-0"
                        tag="a"
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Ver e imprimir
                    </ButtonIcon>
                    <ButtonIcon
                        color="falcon-default"
                        size="sm"
                        icon="arrow-down"
                        className="mr-2 mb-2 mb-sm-0"
                        tag="a"
                        href={url}
                        download={fileName}
                    >
                        Descargar
                    </ButtonIcon>
                </div>
            );
        }}
    </BlobProvider>
);

const SuccessModal = ({ open, data, onOk }) => {
    const referencia = data?.numeroSolicitud || '';
    // La libranza sale de los mismos datos del formato: es el otro documento que
    // el cliente firma en la visita, y la entidad pagadora lo devuelve sellado.
    // Solo acompaña a los créditos por descuento de nómina.
    const esLibranza = String(data?.idLinea) === CREDIT_LINE_ID.LIBRANZA;
    const libranza = esLibranza ? libranzaDesdeFormato(data) : null;

    return (
        <Modal size="lg" isOpen={open}>
            <ModalHeader>
                <h5>Solicitud de Crédito</h5>
                <span className="text-primary" style={{ fontSize: '0.8em' }}>
                    {referencia ? `Solicitud ${referencia}` : ''}
                </span>
            </ModalHeader>
            <ModalBody className="p-3">
                <div className="text-center mt-4">
                    <FontAwesomeIcon icon="check" transform="shrink-2" className="text-success mr-1 fs-8" />
                    <h6 className="fs-2 m-3">Solicitud Creada!</h6>
                    <p className="fs--1">
                        {libranza
                            ? 'Imprima el formato y la libranza, complete a mano la liquidación y las declaraciones, y recójalos firmados por el cliente.'
                            : 'Imprima el formato, complete a mano la liquidación y las declaraciones, y recójalo firmado por el cliente.'}
                    </p>
                    {data && (
                        <>
                            <Documento
                                etiqueta="Formato de solicitud"
                                documento={<SolicitudFormato data={data} />}
                                fileName={`solicitud_credito_${referencia}.pdf`}
                            />
                            {libranza && (
                                <Documento
                                    etiqueta="Libranza"
                                    documento={<LibranzaFormato data={libranza} />}
                                    fileName={`libranza_${libranza.numero || referencia}.pdf`}
                                />
                            )}
                        </>
                    )}
                </div>
            </ModalBody>
            <ModalFooter className="no-border">
                <Col className="text-right">
                    <Button onClick={onOk} transform="shrink-3 down-2" color="primary">
                        Aceptar
                    </Button>
                </Col>
            </ModalFooter>
        </Modal>
    );
};

export default SuccessModal;
